import { Plugin } from 'ckeditor5';

const buildFormData = (file) => {
	const formData = new FormData();
	formData.append('uploadfile', file);
	if (file.type) {
		formData.append('fileType', file.type);
	}
	formData.append('eventType', 'drag');
	formData.append('fileNameOnly', file.name || '');
	formData.append(
		'random'
		, parseFloat(
			Math.floor(Math.random() * 6)
			+ '1'
			+ Math.floor('' + new Date() / 1000)
		)
	);
	return formData;
};

export default class FileDropUpload extends Plugin {
	static get pluginName() {
		return 'FileDropUpload';
	}

	init() {
		const editor = this.editor;
		const options = editor.config.get('centionFileDrop') || {};
		const view = editor.editing.view;
		const viewDocument = view.document;

		this.listenTo(viewDocument, 'drop', (evt, data) => {
			const dataTransfer = data.dataTransfer;

			if (!dataTransfer || !dataTransfer.files || dataTransfer.files.length === 0) {
				return;
			}

			const otherFiles = Array.from(dataTransfer.files).filter(file => {
				return file && !(file.type && file.type.startsWith('image/'));
			});

			if (otherFiles.length === 0) {
				return;
			}

			if (typeof options.onDragnDropFiles !== 'function') {
				return;
			}

			evt.stop();
			data.preventDefault();

			otherFiles.forEach(file => {
				const fd = buildFormData(file);
				const callback = options.onDragnDropFiles(
					fd
					, { name: file.name, type: file.type }
					, file
				);
				if (callback && typeof callback.then === 'function') {
					callback.then(uploaded => {
						if (typeof options.onFileDrop === 'function') {
							options.onFileDrop(uploaded);
						}
					}).catch(error => {
						console.error('FileDropUpload: Failed to upload dropped file', error);
					});
				}
			});
		}, { priority: 'high' });
	}
}
